<script lang="ts">
	import { getImageUrl } from '../../../utils/getImageUrl';
	import { Hero } from '../../Hero';

	interface Props {
		class?: string;
		featuredSection?: {
			Shop_Featured_Section_id?: {
				desktop_image?: {
					filename_disk?: string | null;
				} | null;
				mobile_image?: {
					filename_disk?: string | null;
				} | null;
				link?: string | null;
				surtitle?: string | null;
				subtitle?: string | null;
				title?: string | null;
			} | null;
		} | null;
		index?: number;
		enforcedDesktopImage?: string | null;
		enforcedMobileImage?: string | null;
		desktopImageStyle?: string;
		mobileImageStyle?: string;
	}

	let {
		featuredSection,
		index = 0,
		enforcedDesktopImage,
		enforcedMobileImage,
		desktopImageStyle,
		mobileImageStyle,
		...rest
	}: Props = $props();

	let section = $derived(featuredSection?.Shop_Featured_Section_id);

	let desktopImage = $derived(
		enforcedDesktopImage || getImageUrl(section?.desktop_image?.filename_disk, '2048px')
	);

	let mobileImage = $derived(
		enforcedMobileImage || getImageUrl(section?.mobile_image?.filename_disk, '2048px')
	);
</script>

<a href={section?.link} class="xl:h-[calc(100vw/3)]">
	<Hero
		layerOpacity={index ? 0.2 : 0.3}
		dataCy="shop-home"
		alt="shop"
		mobileSrc={mobileImage}
		src={desktopImage}
		title={`${section?.surtitle}`}
		subtitle={section?.title}
		titleVariant="h4"
		class="z-[9] xl:h-[calc(100vw/3)] {rest.class}"
		classes={{
			title: 'tracking-[2px] mb-4',
			subtitle:
				'lg:max-w-[80%] text-[2rem] md:text-[3rem] mb-5 leading-[2.25rem] md:leading-[3.25rem]',
			description: 'text-[1.5rem] md:-text-[2rem]'
		}}
		description={section?.subtitle}
		{desktopImageStyle}
		{mobileImageStyle}
		priority={false}
	/>
</a>
